const getUserFriendlyMessages = function (operationType, objectName) {
  return {
    msgBody: `Successfully ${operationType} ${objectName}`,
    msgError: false,
  };
};

export default getUserFriendlyMessages;
